<template>
    <div class="wlx-exam-center-table-wrapper">
        <div class="basic-head-main" :style="{ backgroundImage: 'url(' + headBg + ')' }">
            <div class="basic-head-con">
                <div class="head-title-con clearfix">
                    <div class="fl basic-book-img-con">
                        <img src="~assets/images/basic-book-img.png" alt />
                    </div>
                    <div class="fr head-title-word">
                        <p class="p-title-1">认证考核站点申请表</p>
                        <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="apply-table-content" id="export_word">
            <table border="0" cellspacing="0" cellpadding="0">
                <tr>
                    <td class="u-label-title" colspan="2">单位名称</td>
                    <td colspan="13">
                        <!-- <el-input v-model="unitName"></el-input> -->
                        <!-- <el-select v-model="unitName" filterable placeholder="请选择单位" style="width:600px" @change="getCity"> -->
                        <el-select v-model="unitName" filterable placeholder="请选择单位" style="width:600px">
                            <el-option v-for="item in siteList" :key="item.value" :label="item.label" :value="item.label"> </el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td class="u-label-title" colspan="2">通讯地址</td>
                    <td colspan="6">
                        <el-input v-model="address"></el-input>
                    </td>
                    <td class="u-label-title" colspan="1">邮编</td>
                    <td colspan="6">
                        <el-input v-model="email"></el-input>
                    </td>
                </tr>
                <tr>
                    <td class="u-label-title" colspan="2"></td>
                    <td class="u-label-title" colspan="2">姓名</td>
                    <td class="u-label-title" colspan="2">职务/职称</td>
                    <td class="u-label-title" colspan="3">联系电话(常用固定电话)</td>
                    <td class="u-label-title" colspan="3">手机号</td>
                    <td class="u-label-title" colspan="3">电子邮件/传真</td>
                </tr>
                <tr>
                    <td class="u-label-title" colspan="2">法人代表</td>
                    <td class="u-label-title" colspan="2">
                        <el-input v-model="legalPerfon.name"></el-input>
                    </td>
                    <td class="u-label-title" colspan="2">
                        <el-input v-model="legalPerfon.job"></el-input>
                    </td>
                    <td class="u-label-title" colspan="3">
                        <el-input v-model="legalPerfon.phone"></el-input>
                    </td>
                    <td class="u-label-title" colspan="3">
                        <el-input v-model="legalPerfon.mobilePhone"></el-input>
                    </td>
                    <td class="u-label-title" colspan="3">
                        <el-input v-model="legalPerfon.email"></el-input>
                    </td>
                </tr>
                <tr>
                    <td class="u-label-title" colspan="2">联系人</td>
                    <td class="u-label-title" colspan="2">
                        <el-input v-model="linkPerson.name"></el-input>
                    </td>
                    <td class="u-label-title" colspan="2">
                        <el-input v-model="linkPerson.job"></el-input>
                    </td>
                    <td class="u-label-title" colspan="3">
                        <el-input v-model="linkPerson.phone"></el-input>
                    </td>
                    <td class="u-label-title" colspan="3">
                        <el-input v-model="linkPerson.mobilePhone"></el-input>
                    </td>
                    <td class="u-label-title" colspan="3">
                        <el-input v-model="linkPerson.email"></el-input>
                    </td>
                </tr>
                <tr>
                    <td class="u-label-title" colspan="2">负责区域</td>
                    <td class="u-label-title" colspan="13">
                        <div class="select-area-con">
                            <span>考核区域:</span>
                            <span class="sp-area-label">省</span>
                            <el-select v-model="provinceValue" placeholder="请选择省份" @change="getCityData">
                                <el-option v-for="item in provinceOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <!-- <span class="sp-city-con">{{provinceValue}}</span> -->
                            <span class="sp-area-label">市</span>
                            <el-select v-model="cityValue" placeholder="请选择地市">
                                <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <!-- <span class="sp-city-con" >{{cityValue}}</span> -->
                        </div>
                    </td>
                </tr>
                <tr v-if="certificateId=='dnmeaa2seqbkn9fqiaawfq'">
                    <td class="u-label-title" colspan="2" rowspan="3">考试场地及设备情况（选择需要的考核方式）</td>
                    <td class="u-label-title" colspan="3">实操考核方式</td>
                    <td class="u-label-title" colspan="10">
                        <!-- <el-input v-model="examAddress"></el-input> -->
                        <el-radio-group v-model="isOnline">
                            <el-radio :label="0">线下考核</el-radio>
                            <el-radio :label="1">线上考核</el-radio>
                        </el-radio-group>
                    </td>
                </tr>
                <tr v-if="certificateId=='dnmeaa2seqbkn9fqiaawfq'">
                    <td class="u-label-title" colspan="3">场地地点</td>
                    <td class="u-label-title" colspan="10">
                        <el-input v-model="examAddress"></el-input>
                    </td>
                </tr>
                <tr v-if="certificateId=='0j6eacat97rafjaiqtfazg'">
                    <td class="u-label-title" colspan="2" rowspan="2">考试场地及设备情况</td>
                    <td class="u-label-title" colspan="3">场地地点</td>
                    <td class="u-label-title" colspan="10">
                        <el-input v-model="examAddress"></el-input>
                    </td>
                </tr>

                <tr>
                    <td class="u-label-title" colspan="3">负责人</td>
                    <td class="u-label-title" colspan="10">
                        <el-input v-model="examPerson"></el-input>
                    </td>
                </tr>
                <tr>
                    <td class="u-label-title" colspan="1" rowspan="13">人员配配备情况</td>
                    <td class="u-label-title" colspan="1">人员</td>
                    <td class="u-label-title" colspan="2">姓名</td>
                    <td class="u-label-title" colspan="1">性别</td>
                    <td class="u-label-title" colspan="2">专/兼职</td>
                    <td class="u-label-title" colspan="2">职称</td>
                    <td class="u-label-title" colspan="1">专业工龄</td>
                    <td class="u-label-title" colspan="5">所属单位名称</td>
                </tr>
                <tr v-for="(item, index) in managerPerson" :key="index">
                    <td colspan="1" rowspan="4" v-if="index == 0" class="u-label-title">管理人员</td>
                    <td colspan="2">
                        <el-input v-model="item.name"></el-input>
                    </td>
                    <td colspan="1">
                        <el-select v-model="item.sex" placeholder="">
                            <el-option label="男" value="男"></el-option>
                            <el-option label="女" value="女"></el-option>
                        </el-select>
                    </td>
                    <td colspan="2">
                        <el-select v-model="item.isFullTime" placeholder="">
                            <el-option label="专职" value="专职"></el-option>
                            <el-option label="兼职" value="兼职"></el-option>
                        </el-select>
                    </td>
                    <td colspan="2">
                        <el-input v-model="item.jobTitle"></el-input>
                    </td>
                    <td colspan="1">
                        <el-input v-model="item.jobYear"></el-input>
                    </td>
                    <td colspan="5">
                        <el-input v-model="item.unitName"></el-input>
                    </td>
                </tr>
                <tr v-for="(item, index) in evaluator" :key="index + 'e'">
                    <td colspan="1" rowspan="4" v-if="index == 0" class="u-label-title">考评员</td>
                    <td colspan="2">
                        <el-input v-model="item.name"></el-input>
                    </td>
                    <td colspan="1">
                        <el-select v-model="item.sex" placeholder="">
                            <el-option label="男" value="男"></el-option>
                            <el-option label="女" value="女"></el-option>
                        </el-select>
                    </td>
                    <td colspan="2">
                        <el-select v-model="item.isFullTime" placeholder="">
                            <el-option label="专职" value="专职"></el-option>
                            <el-option label="兼职" value="兼职"></el-option>
                        </el-select>
                    </td>
                    <td colspan="2">
                        <el-input v-model="item.jobTitle"></el-input>
                    </td>
                    <td colspan="1">
                        <el-input v-model="item.jobYear"></el-input>
                    </td>
                    <td colspan="5">
                        <el-input v-model="item.unitName"></el-input>
                    </td>
                </tr>
                <tr v-for="(item, index) in administrators" :key="index + 'k'">
                    <td colspan="1" rowspan="4" v-if="index == 0" class="u-label-title">系统管理员</td>
                    <td colspan="2">
                        <el-input v-model="item.name"></el-input>
                    </td>
                    <td colspan="1">
                        <el-select v-model="item.sex" placeholder="">
                            <el-option label="男" value="男"></el-option>
                            <el-option label="女" value="女"></el-option>
                        </el-select>
                    </td>
                    <td colspan="2">
                        <el-select v-model="item.isFullTime" placeholder="">
                            <el-option label="专职" value="专职"></el-option>
                            <el-option label="兼职" value="兼职"></el-option>
                        </el-select>
                    </td>
                    <td colspan="2">
                        <el-input v-model="item.jobTitle"></el-input>
                    </td>
                    <td colspan="1">
                        <el-input v-model="item.jobYear"></el-input>
                    </td>
                    <td colspan="5">
                        <el-input v-model="item.unitName"></el-input>
                    </td>
                </tr>
            </table>

            <el-button type="primary" size="medium" style="margin-top:10px;margin-left:580px;" @click="saveInfo">
                确定考核站点申请表信息
            </el-button>

            <el-button type="primary" size="medium" style="margin-top:10px;" @click="getExportSQBUrl">
                导出认证考核站点申请表
            </el-button>
        </div>
        <div class="apply-table-contents">
            <div class="p-upload-apply-doc clearfix">
                <span class="sp-upload-file-label" v-if="certificateId=='0j6eacat97rafjaiqtfazg'">供应链运营职业技能等级证书考核站点申请表:</span>
                 <span class="sp-upload-file-label" v-if="certificateId=='dnmeaa2seqbkn9fqiaawfq'">物流管理职业技能等级证书考核站点申请表:</span>
                <applyFileUpload :url="urlAliyunOSS" :files="files" @done="onAllFilesUpload" class="apply-file-upload"></applyFileUpload>
            </div>
            <div class="p-upload-apply-doc clearfix" v-if="certificateId=='0j6eacat97rafjaiqtfazg'">
                <span class="sp-upload-file-label">考试相对固定的场所和相关设备的证明文件（ <span style="color: #ee5656">请上传体现考试机房，实训考场（实训设备，监控设备等）的照片或文件以方便审核</span>）:</span> 
                <!-- <p> <i class="wl-icon-wanfashuoming"></i> 请上传体现手持终端型号及数量，考试机房，实训考场（货架，纸箱，监控设备等）的照片或文件以方便审核</p> -->
                <applyFileUpload :url="urlAliyunOSS" :files="files" @done="onAllFilesUploada" class="apply-file-upload"></applyFileUpload>
            </div>

             <div class="p-upload-apply-doc clearfix" v-if="certificateId=='dnmeaa2seqbkn9fqiaawfq'">
                <span class="sp-upload-file-label">考试相对固定的场所和相关设备的证明文件（ <span style="color: #ee5656">请上传体现手持终端型号及数量，考试机房，实训考场（货架，纸箱，监控设备等）的照片或文件以方便审核</span>）:</span> <span style="color:#409EFF;cursor: pointer;" @click="()=>dialogVisible = true">查看示例</span>
                <!-- <p> <i class="wl-icon-wanfashuoming"></i> 请上传体现手持终端型号及数量，考试机房，实训考场（货架，纸箱，监控设备等）的照片或文件以方便审核</p> -->
                <applyFileUpload :url="urlAliyunOSS" :files="files" @done="onAllFilesUploada" class="apply-file-upload"></applyFileUpload>
            </div>

            <div class="p-upload-apply-doc clearfix">
                <span class="sp-upload-file-label">办学机构简介:</span>
                <applyFileUpload :url="urlAliyunOSS" :files="files" @done="onAllFilesUploadb" class="apply-file-upload"></applyFileUpload>
            </div>
            <div class="p-upload-apply-doc clearfix">
                <span class="sp-upload-file-label">办学机构法人资格证明文件（院校无需提供该证明文件）:</span>
                <applyFileUpload :url="urlAliyunOSS" :files="files" @done="onAllFilesUploadc" class="apply-file-upload"></applyFileUpload>
            </div>
            <div class="p-upload-apply-doc clearfix">
                <span class="sp-upload-file-label">承诺书（院校需要下载，并在盖章后上传）:
                    <a :href="gylCNS" v-if="certificateId=='0j6eacat97rafjaiqtfazg'">承诺书文件下载</a>
                    <a :href="LOUUrl" v-if="certificateId=='dnmeaa2seqbkn9fqiaawfq'">承诺书文件下载</a>
                    </span>
                <applyFileUpload :url="urlAliyunOSS" :files="files" @done="onAllFilesUploadlLOU" class="apply-file-upload"></applyFileUpload>
            </div>
            <div class="submit-apply-btn">
                <el-button type="primary" @click="submitApply" :disabled="isSubmit">提交申请</el-button>
                <!-- <el-button type="primary" @click="submitApply" :disabled="true">提交申请</el-button>
        <span style="color:red">申报考核站点已截止,无法继续修改申报信息</span> -->
                <!-- <el-button type="primary" @click="Export" >导出</el-button> -->
            </div>
        </div>
        <el-dialog title="" :visible.sync="dialogVisible" :close-on-click-modal="false" width="816px" class="wlx-examples-con" :show-close="false">
            <div class="wlx-is-fill-signUp-con">
                <p class="p-text-tip">请选择类似下图四张分别为：货架，纸箱，电脑，手持的图片进行上传</p>
                <div class="clearfix examples-list-img">
                    <div class="fl examples-li-fl">
                        <img src="https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/sQSdJkKddTF8s3FR.jpg" class="one-cover-img" alt="">
                        <img src="https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/2XBn75yZ5jwWxHwN.jpg" class="two-cover-img" alt="">
                    </div>
                    <div class="fl examples-li-fr">
                        <img src="https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/Nrch3pk7kcratr2x.jpg" alt="">
                    </div>
                    <div class="fl examples-li-min">
                        <img src="https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/wK8Xy3T2NEnbXbY3.jpg" alt="" />
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import applyFileUpload from "components/uploads/uploadEnclosure.vue";
export default {
    data() {
        return {
            dialogVisible: false,
            headBg: require("assets/images/wlx-baic-bg-img.png"),
            unitName: "",
            address: "",
            email: "",
            legalPerfon: {
                name: "",
                job: "",
                phone: "",
                mobilePhone: "",
                email: "",
            },
            linkPerson: {
                name: "",
                job: "",
                phone: "",
                mobilePhone: "",
                email: "",
            },
            managerPerson: [
                {
                    name: "",
                    sex: "",
                    isFullTime: "",
                    jobTitle: "",
                    jobYear: "",
                    unitName: "",
                },
                {
                    name: "",
                    sex: "",
                    isFullTime: "",
                    jobTitle: "",
                    jobYear: "",
                    unitName: "",
                },
                {
                    name: "",
                    sex: "",
                    isFullTime: "",
                    jobTitle: "",
                    jobYear: "",
                    unitName: "",
                },
                {
                    name: "",
                    sex: "",
                    isFullTime: "",
                    jobTitle: "",
                    jobYear: "",
                    unitName: "",
                },
            ],
            evaluator: [
                {
                    name: "",
                    sex: "",
                    isFullTime: "",
                    jobTitle: "",
                    jobYear: "",
                    unitName: "",
                },
                {
                    name: "",
                    sex: "",
                    isFullTime: "",
                    jobTitle: "",
                    jobYear: "",
                    unitName: "",
                },
                {
                    name: "",
                    sex: "",
                    isFullTime: "",
                    jobTitle: "",
                    jobYear: "",
                    unitName: "",
                },
                {
                    name: "",
                    sex: "",
                    isFullTime: "",
                    jobTitle: "",
                    jobYear: "",
                    unitName: "",
                },
            ],
            administrators: [
                {
                    name: "",
                    sex: "",
                    isFullTime: "",
                    jobTitle: "",
                    jobYear: "",
                    unitName: "",
                },
                {
                    name: "",
                    sex: "",
                    isFullTime: "",
                    jobTitle: "",
                    jobYear: "",
                    unitName: "",
                },
                {
                    name: "",
                    sex: "",
                    isFullTime: "",
                    jobTitle: "",
                    jobYear: "",
                    unitName: "",
                },
                {
                    name: "",
                    sex: "",
                    isFullTime: "",
                    jobTitle: "",
                    jobYear: "",
                    unitName: "",
                },
            ],
            examAddress: "",
            isOnline:"",
            examPerson: "",
            provinceOption: [],
            cityOptions: [],
            provinceValue: "",
            cityValue: "",
            isSubmit: false,
            timer: null,
            fileIds: [],
            fileaIds: [],
            filebIds: [],
            filecIds: [],
            fileLOUIds: [],
            files: [],
            gylCNS:"https://file.clpp.org.cn/ykt/ori/pzuvaesrpafgwt3kofbgag/TdSSxX4kQPx8hKwN.docx?response-content-disposition=attachment;filename=供应链运营职业技能等级证书考核站点承诺书.docx",
            LOUUrl: "https://file.clpp.org.cn/66ykt/ori/62aoalgo67ralzns3hnyea/xcmrPH42MRYpF3d6.docx?response-content-disposition=attachment;filename=考核站点承诺书.docx",
            urlAliyunOSS: "/api/design/osssign/getsign",
            siteList: [],
            id: "",
        };
    },
    components: {
        applyFileUpload,
    },
    // computed: {
    //   exportSQBUrl() {
    //     return "/api/XOrg/AssessmentApply/exportSQBUrl?id="+this.id;
    //   }
    // },
    created() {
        this.getProvinceData();
        this.getSiteList();
    },
    props: {
        certificateId: {
            type: String,
            default: "",
        },
    },
    methods: {
        // getCity(){
        //  this.$http
        //     .post("/api/XOrg/AssessmentApply/getCity", {
        //       id:this.unitName
        //     })
        //     .then(res => {
        //       if (res.code > 0) {
        //         this.provinceValue = res.schoolInfo.SchoolProvince;
        //         this.cityValue = res.schoolInfo.SchoolCity;
        //       } else {
        //         this.$message.warning(res.msg);
        //         return;
        //       }
        //     });
        // },
        Export() {
            $("#export_word").wordExport();
        },
        getExportSQBUrl() {
            if (this.id) {
                window.location.href = "/api/XOrg/AssessmentApply/exportSQBUrl?id=" + this.id+"&certificateId="+this.certificateId;
            } else {
                this.$message.warning("请先确定考核站点申请表信息");
            }
        },
        onAllFilesUpload(files) {
            this.fileIds = [];
            this.fileIds = files;
        },
        onAllFilesUploada(files) {
            this.fileaIds = [];
            this.fileaIds = files;
        },
        onAllFilesUploadb(files) {
            this.filebIds = [];
            this.filebIds = files;
        },
        onAllFilesUploadc(files) {
            this.filecIds = [];
            this.filecIds = files;
        },
        onAllFilesUploadlLOU(files) {
            this.fileLOUIds = [];
            this.fileLOUIds = files;
        },
        getProvinceData() {
            this.$http.post("/api/XOrg/Special/getAllProvinceList").then((res) => {
                if (res.code > 0) {
                    this.provinceOption = res.province;
                } else {
                    this.$message.warning(res.msg);
                    return;
                }
            });
        },
        getCityData() {
            this.cityValue = "";
            this.$http
                .post("/api/XOrg/Special/getCityList", {
                    province: this.provinceValue,
                })
                .then((res) => {
                    if (res.code > 0) {
                        this.cityOptions = res.cityList;
                    } else {
                        this.$message.warning(res.msg);
                        return;
                    }
                });
        },

        saveInfo() {
            const reg = /^1\d{10}$/;
            if (this.unitName == "") {
                this.$message.warning("请输入单位名称");
                return false;
            }
            if (this.address == "") {
                this.$message.warning("请输入通讯地址");
                return false;
            }
            if (this.email == "") {
                this.$message.warning("请输入邮编");
                return false;
            }
            if (this.legalPerfon.name == "") {
                this.$message.warning("请输入法人代表姓名");
                return false;
            }
            if (this.legalPerfon.job == "") {
                this.$message.warning("请输入法人代表职务");
                return false;
            }
            if (this.legalPerfon.phone == "") {
                this.$message.warning("请输入法人代表联系电话");
                return false;
            }
            if (this.legalPerfon.mobilePhone == "") {
                this.$message.warning("请输入法人代表手机号");
                return false;
            }
            if (this.legalPerfon.email == "") {
                this.$message.warning("请输入法人代表邮件或传真");
                return false;
            }
            if (this.linkPerson.name == "") {
                this.$message.warning("请输入联系人姓名");
                return false;
            }
            if (this.linkPerson.job == "") {
                this.$message.warning("请输入联系人职务");
                return false;
            }
            if (this.linkPerson.phone == "") {
                this.$message.warning("请输入联系人联系电话");
                return false;
            }
            if (this.linkPerson.mobilePhone == "") {
                this.$message.warning("请输入联系人手机号");
                return false;
            }
            if (this.linkPerson.email == "") {
                this.$message.warning("请输入联系人邮件或传真");
                return false;
            }
            if (this.provinceValue == "") {
                this.$message.warning("请选择省份");
                return false;
            }
            if (this.cityValue == "") {
                this.$message.warning("请选择地市");
                return false;
            }
            if (this.examAddress == "") {
                this.$message.warning("请输入考试地点");
                return false;
            }

            // if (this.isOnline === "") {
            //     this.$message.warning("请选择实操考核方式");
            //     return false;
            // }


            if (this.examPerson == "") {
                this.$message.warning("请输入负责人姓名");
                return false;
            }
            this.$http
                .post("/api/XOrg/AssessmentApply/addAssessmentApply", {
                    SchoolName: this.unitName,
                    Address: this.address,
                    Email: this.email,
                    LegalName: this.legalPerfon.name,
                    LegalPost: this.legalPerfon.job,
                    LegalPhone: this.legalPerfon.phone,
                    LegalMobilePhone: this.legalPerfon.mobilePhone,
                    LegalEmail: this.legalPerfon.email,
                    ContactsName: this.linkPerson.name,
                    ContactsPost: this.linkPerson.job,
                    ContactsPhone: this.linkPerson.phone,
                    ContactsMobilePhone: this.linkPerson.mobilePhone,
                    ContactsEmail: this.linkPerson.email,
                    ResponsibleProvince: this.provinceValue,
                    ResponsibleCity: this.cityValue,
                    Place: this.examAddress,
                    PlacePerson: this.examPerson,
                    PersonJson: JSON.stringify(this.managerPerson),
                    ExaminerJson: JSON.stringify(this.evaluator),
                    AdministratorsJson: JSON.stringify(this.administrators),
                    certificateId: this.certificateId,
                    isOnline: this.isOnline
                })
                .then((res) => {
                    if (res.code > 0) {
                        this.id = res.id;
                        //this.isSubmit = true;
                        this.$message.success(res.msg);
                    } else {
                        this.$message.warning(res.msg);
                        return;
                    }
                });
        },

        submitApply() {
            const reg = /^1\d{10}$/;
            if (this.unitName == "") {
                this.$message.warning("请输入单位名称");
                return false;
            }
            if (this.address == "") {
                this.$message.warning("请输入通讯地址");
                return false;
            }
            if (this.email == "") {
                this.$message.warning("请输入邮编");
                return false;
            }
            // if (this.legalPerfon.name == "") {
            //   this.$message.warning("请输入法人代表姓名");
            //   return false;
            // }
            // if (this.legalPerfon.job == "") {
            //   this.$message.warning("请输入法人代表职务");
            //   return false;
            // }
            // if (this.legalPerfon.phone == "") {
            //   this.$message.warning("请输入法人代表联系电话");
            //   return false;
            // }
            // if (this.legalPerfon.mobilePhone == "") {
            //   this.$message.warning("请输入法人代表手机号");
            //   return false;
            // }
            // if (this.legalPerfon.email == "") {
            //   this.$message.warning("请输入法人代表邮件或传真");
            //   return false;
            // }
            if (this.linkPerson.name == "") {
                this.$message.warning("请输入联系人姓名");
                return false;
            }
            if (this.linkPerson.job == "") {
                this.$message.warning("请输入联系人职务");
                return false;
            }
            if (this.linkPerson.phone == "") {
                this.$message.warning("请输入联系人联系电话");
                return false;
            }
            if (this.linkPerson.mobilePhone == "") {
                this.$message.warning("请输入联系人手机号");
                return false;
            }
            if (this.linkPerson.email == "") {
                this.$message.warning("请输入联系人邮件或传真");
                return false;
            }
            if (this.provinceValue == "") {
                this.$message.warning("请选择省份");
                return false;
            }
            if (this.cityValue == "") {
                this.$message.warning("请选择地市");
                return false;
            }
            if (this.examAddress == "") {
                this.$message.warning("请输入考核地点");
                return false;
            }

            // if (this.isOnline === "") {
            //     this.$message.warning("请选择实操考核方式");
            //     return false;
            // }
            
            if (this.examPerson == "") {
                this.$message.warning("请输入负责人姓名");
                return false;
            }
            // if (this.files == "") {
            //   this.$message.warning("请上传认证考核站点申请表");
            //   return false;
            // }
            // if (this.fileas == "") {
            //   this.$message.warning("请上传考试相对固定的场所和相关设备的证明文件");
            //   return false;
            // }
            this.$http
                .post("/api/XOrg/AssessmentApply/addAssessmentApply", {
                    id: this.id,
                    SchoolName: this.unitName,
                    Address: this.address,
                    Email: this.email,
                    LegalName: this.legalPerfon.name,
                    LegalPost: this.legalPerfon.job,
                    LegalPhone: this.legalPerfon.phone,
                    LegalMobilePhone: this.legalPerfon.mobilePhone,
                    LegalEmail: this.legalPerfon.email,
                    ContactsName: this.linkPerson.name,
                    ContactsPost: this.linkPerson.job,
                    ContactsPhone: this.linkPerson.phone,
                    ContactsMobilePhone: this.linkPerson.mobilePhone,
                    ContactsEmail: this.linkPerson.email,
                    ResponsibleProvince: this.provinceValue,
                    ResponsibleCity: this.cityValue,
                    Place: this.examAddress,
                    isOnline: this.isOnline,
                    PlacePerson: this.examPerson,
                    PersonJson: JSON.stringify(this.managerPerson),
                    ExaminerJson: JSON.stringify(this.evaluator),
                    AdministratorsJson: JSON.stringify(this.administrators),
                    files: JSON.stringify(this.fileIds),
                    fileas: JSON.stringify(this.fileaIds),
                    filebs: JSON.stringify(this.filebIds),
                    filecs: JSON.stringify(this.filecIds),
                    fileLOUs: JSON.stringify(this.fileLOUIds),
                    certificateId: this.certificateId,
                })
                .then((res) => {
                    if (res.code > 0) {
                        this.isSubmit = true;
                        this.$message.success("申请成功,即将跳转到管理系统!");
                        this.timer = setInterval(this.goclpp, 3000);
                    } else {
                        this.$message.warning(res.msg);
                        return;
                    }
                });
        },
        getSiteList() {
            this.$http.post("/api/XOrg/AssessmentApply/getSiteList").then((res) => {
                if (res.code > 0) {
                    this.siteList = res.list;
                } else {
                    this.$message.warning(res.msg);
                    return;
                }
            });
        },
        downloadTable() {
            this.$http.post("/api/XOrg/TrainApply/eportTrainApply", {
                TrainApplyId: this.trainApplyId,
            });
        },
        goclpp() {
            this.$router.push({
                name: "assessmentApplyTea",
            });
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
};
</script>

<style lang="scss">
.apply-table-contents {
    width: 1000px;
    margin: 0 auto;
}
.sp-city-con {
    background: #fff;
    display: inline-block;
    width: 220px;
    line-height: 40px;
    padding: 0 10px;
}
.wlx-exam-center-table-wrapper {
    .el-upload-list {
        background: #fff;
    }
}
</style>
